const fetch = require('isomorphic-fetch');

const statusIsOK = (status) => {
    let result = false;
    switch (status) {
        case 200:
            result = true;
            break;
    }
    return result;
};

module.exports = {
    get: (url, params = {}) => {
        return fetch
            (url, Object.assign({headers: {
                'Accept': 'application/json'
            }}, params))
            .then(response => {
                let {status} = response;

                if (statusIsOK(status)) {
                    return response.json();
                } else {
                    throw new Error();
                }
            })
            .catch(e => {
                console.log(`Could not fetch ${url}`, e.stack, e);
                throw e;
            })
    },
    post: (url, params = {}, body = {}) => {
        return fetch(url, Object.assign({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            }, params))
            .then(response => {
                let {status} = response;

                if (statusIsOK(status)) {
                    return response[params.responseType || 'json']();
                } else {
                    throw new Error();
                }
            })
            .catch(e => {
                console.log(`Could not post ${url}`, e);
                throw e;
            })
    }
}



/** WEBPACK FOOTER **
 ** ../src/common/fetch.js
 **/